module.exports = __webpack_public_path__ + "static/media/2-8.bab5640a.mp3";